import Overlays from 'diagram-js/lib/features/overlays/Overlays';
import {isEmpty} from "lodash";

export class PathwayOverlays extends Overlays {

  constructor(private config, private eventBus, private canvas, private elementRegistry) {
    super(config, eventBus, canvas, elementRegistry);
  }

  public add(element, overlayType, overlayContent) {
    if (!element.id) {
      element = this.elementRegistry.get(element);
    }
    const overlay = super.add(element, overlayType, overlayContent);
    this.eventBus.fire('overlay.added', {element: element, overlayType: overlayType});
    return overlay;
  }

  public check(search){
    let overlay = super.get(search);
    if(!isEmpty(overlay)){
      this.eventBus.fire('overlay.checked', {element: search.element, overlayType: search.type});
    }
    return overlay;
  }

}
